import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { ConfigurationsConfig } from '@empathybroker/tsclient-play/dist/models/instance/configurations-config';
import { Attribute } from '@empathybroker/tsclient-search';

import { Location, Route } from 'vue-router';
import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../config';

import { DomainEnum } from '../enums';

import { GuardClass, GuardResolveFunction } from '../models';

import { ROUTER_CONSTS } from '../router/router.consts';

import { CONFIG_CONSTS } from '../store/config/config.consts';
import { SEARCH_CONSTS } from '../store/search/search.consts';

export class SetAttributeWithUrlGuard extends GuardClass {

  public static async execute(to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    let redirectLocation: Location;
    const attributeName = to.params[ROUTER_CONSTS.params.attribute.name];
    const store = CONTAINER.get<Store<any>>(TYPES.Store);
    const instanceConfig = store.getters[`${ CONFIG_CONSTS.moduleName }/${ CONFIG_CONSTS.getters.currentInstance }`];
    const configurationsToolConfig: ConfigurationsConfig = (!!instanceConfig.tools
      ? instanceConfig.tools[ActionTypeEnum.CONFIGURATION] : undefined);
    const availableAttributeNames = (!!configurationsToolConfig ? configurationsToolConfig.attributeNames : []);
    if (!!availableAttributeNames.length) {
      if (!attributeName || !availableAttributeNames.includes(attributeName)) {
        redirectLocation = {
          ...to,
          name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attribute,
          params: {
            ...to.params,
            [ROUTER_CONSTS.params.attribute.name]: availableAttributeNames[0],
            [ROUTER_CONSTS.params.attribute.value]: undefined
          }
        };
      } else {
        const attributeValue = to.params[ROUTER_CONSTS.params.attribute.value];
        if (to.name === ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attributes) {
          redirectLocation = {
            ...to,
            name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attribute,
            params: {
              ...to.params,
              [ROUTER_CONSTS.params.attribute.value]: undefined
            }
          };
        } else if (to.name === ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attribute) {
          if (!!attributeValue) {
            redirectLocation = {
              ...to,
              params: {
                ...to.params,
                [ROUTER_CONSTS.params.attribute.value]: undefined
              }
            };
          }
        } else {
          if (!attributeValue) {
            redirectLocation = {
              ...to,
              name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attribute
            };
          } else {
            const attributes = store.getters[`${ SEARCH_CONSTS.moduleName }/${ SEARCH_CONSTS.getters.attributes }`];
            if (!attributes[attributeName]) {
              await store.dispatch(`${ SEARCH_CONSTS.moduleName }/${ SEARCH_CONSTS.actions.loadAttributes }`, {
                attribute: attributeName
              });
            }
            const attributeValues = attributes[attributeName];
            if (!SetAttributeWithUrlGuard.findAttributeById(attributeValue, (attributeValues.items || attributeValues))) {
              redirectLocation = {
                ...to,
                name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attribute,
                params: {
                  ...to.params,
                  [ROUTER_CONSTS.params.attribute.value]: undefined
                }
              };
            }
          }
        }
      }
    } else {
      redirectLocation = {
        ...to,
        name: ROUTER_CONSTS.routes.pageNotFound
      };
    }
    if (!!redirectLocation) {
      redirectLocation.replace = true;
    }
    next(redirectLocation);
  }

  public static findAttributeById(id: string, attributes: (Attribute[] | Attribute), attributeParents: Attribute[] = []) {
    if (!Array.isArray(attributes)) {
      attributes = [attributes];
    }
    for (const attribute of attributes) {
      if (attribute.specificId === id) {
        return {
          ...attribute,
          parents: attributeParents
        };
      } else if (!!attribute.children) {
        attributeParents.push(attribute);
        const attributeChild = SetAttributeWithUrlGuard.findAttributeById(id, attribute.children, attributeParents);
        if (!!attributeChild) {
          return {
            ...attributeChild,
            parents: attributeParents
          };
        } else {
          attributeParents.pop();
        }
      }
    }
  }

}
